import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import Tab from '@material-ui/core/Tab';

interface StyledTabProps {
  label: any;
  value: any;
}

const AntTab = withStyles((theme: Theme) =>
  createStyles({
    root: {
      textTransform: 'none',
      fontWeight: 400,
      fontSize: '13px',
      background: 'white',
      paddingLeft: '2.8vh',
      paddingRight: '2.8vh',
      fontFamily: ['Poppins'].join(','),
      color: '#23296F',
      opacity: 1,
      '& span': {
        fontFamily: 'Poppins',
        fontWeight: 400,
      },
      '& span div span': {
        display: 'block',
        background: '#23296F',
        float: 'right',
        paddingLeft: 7,
        paddingRight: 7,
        color: 'white',
        borderRadius: 35,
        marginLeft: 7,
        fontSize: '12px',
        fontFamily: 'Poppins',
      },
      '&$selected': {
        fontWeight: 50,
        background: '#000A8D',
        color: 'white',
        borderRadius: '50px',
        '& span div span': {
          background: 'white',
          color: '#0E1247',
        },
      },
      '&:focus': {
        color: 'white',
      },
    },
    selected: {},
    scrollButtons: {
      background: 'red',
    },
  })
)((props: StyledTabProps) => <Tab disableRipple={true} {...props} />);

export default AntTab;
